import { css } from 'styled-components'

export const textEllipsis = css`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const linearText = css`
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`
